import Vue from 'vue'
Vue.filter("reviewProductStatus", (v)=>{
  //reviewStatus (integer, optional): 产品状态 0 未审核(推送中) 1 通过或白名单(云仓中) 2 审核未通过或黑名单(未通过) ,
  if(v==0){
    return "推送中"
  }else if(v==1){
    return " 云仓中"
  }else{
    return "未通过"
  }
});
Vue.filter("productStatus", (v)=>{
  if(v==0){
    return "下架"
  }else if(v==1){
    return " 上架"
  }else{
    return "废弃"
  }
});
// 发票过滤器
Vue.filter("invoiceFormatStatus", (value)=>{
  if(value==1){
    return "不提供发票"
  }else if(value==2){
    return " 供应商开发票"
  }else if(value==3){
    return "前台开发票"
  }
});
// 产品类型过滤器
Vue.filter("productTypeFormat", (value) => {
	if (value == 1) {
		return "门票"
	} else if (value == 2) {
		return "酒店"
	} else if (value == 3) {
		return "签证"
	} else if (value == 4) {
		return "景酒"
	} else if (value == 5) {
		return "百货"
	} else if (value == 74) {
		return "国内跟团"
	} else if (value == 75) {
		return "自由行"
	} else if (value == 73) {
		return "出境跟团"
	} else if (value == 8) {
		return "抢购"
	} else if (value == 83) {
		return "预约"
	}
});

// 签证类型过滤器
Vue.filter("visaTypeFormat", (value) => {
	if (value == 1) {
		return "个人旅游"
	} else if (value == 2) {
		return "商务"
	} else if (value == 3) {
		return "探亲访友"
	} else if (value == 4) {
		return "其它"
	}
});

// 签证退款规则
Vue.filter("visaRefundTypeFormat", (value) => {
	if (value == 0) {
		return "全额退款"
	} else if (value == 1) {
		return "部分退款"
	} else if (value == 2) {
		return "不退款"
	}
});

Vue.filter('NumFormat', function (value) {
	// console.log("value",value)
	if (!value) return '0.00';
	var intPart = Math.trunc(value); //获取整数部分
	console.log("获取整数部分",intPart)
	var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
	console.log("将整数部分逢三一断",intPartFormat)
	var floatPart = ".00"; //预定义小数部分
	var value2Array = Number(value).toFixed(2).split(".");
	console.log("value2Array",value2Array)
	//=2表示数据有小数位
	if (value2Array.length == 2) {
		floatPart = value2Array[1].toString(); //拿到小数部分
		if (floatPart.length == 1) { //补0,实际上用不着
			return intPartFormat + "." + floatPart + '0';
		} else {
			return intPartFormat + "." + floatPart;
		}
	} else {
		return intPartFormat + floatPart;
	}
})

// 酒店详情wifi匹配
Vue.filter("hotelWifiFormat", (value) => {
	if (value == 1) {
		return "无"
	} else if (value == 2) {
		return "免费wifi"
	} else if (value == 3) {
		return "收费wifi"
	}
});

// 酒店详情价格计划匹配
Vue.filter("hotelPricePlanFormat", (value) => {
	if (value == 1) {
		return "不可取消"
	} else if (value == 2) {
		return "限时免费取消"
	} else if (value == 3) {
		return "随时免费取消"
	}
});



// WEBPACK FOOTER //
// ./src/filters/index.js